import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useT } from "@/i18n/useT";

export default function ShopPage() {
  const t = useT();
  const s = t.shop;
  const { category } = useParams();
  const navigate = useNavigate();
  const active = category || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const CATEGORIES = [
    { slug: "all", label: s.filters.all },
    { slug: "amber-jewelry", label: s.filters.amber },
    { slug: "linen-clothing", label: s.filters.linen },
    { slug: "baltic-decor", label: s.filters.decor },
    { slug: "gifts", label: s.filters.gifts },
  ];

  useEffect(() => {
    setLoading(true);
    api.get(active === "all" ? "/products" : `/products?category=${active}`)
      .then(({ data }) => setProducts(data.products || []))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="shop-page" className="br-container py-20 md:py-28">
      <header className="mb-16 md:mb-20 max-w-2xl br-fade-in">
        <div className="br-eyebrow mb-4">{s.eyebrow}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-espresso leading-tight">{s.title}</h1>
        <p className="mt-6 text-base font-light text-dark-walnut leading-relaxed max-w-xl">{s.body}</p>
      </header>
      <div data-testid="shop-filters" className="flex flex-wrap items-center gap-x-8 gap-y-3 mb-12 md:mb-16 border-b border-walnut/20 pb-6">
        {CATEGORIES.map((c) => (
          <button key={c.slug} data-testid={`filter-${c.slug}`} onClick={() => navigate(c.slug === "all" ? "/shop" : `/shop/${c.slug}`)}
            className={`text-xs uppercase tracking-[0.3em] transition-colors duration-300 ${active === c.slug ? "text-walnut" : "text-espresso/60 hover:text-espresso"}`}>
            {c.label}
          </button>
        ))}
      </div>
      {loading ? <div data-testid="shop-loading" className="py-32 text-center text-walnut text-sm italic">{s.loading}</div>
        : products.length === 0 ? <div data-testid="shop-empty" className="py-32 text-center text-walnut text-sm italic">{s.empty}</div>
        : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
            {products.map((p) => <div key={p.id} className="br-fade-in"><ProductCard product={p} /></div>)}
          </div>}
    </div>
  );
}